
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { Users, PlusCircle } from "lucide-react";
import { motion } from "framer-motion";

const TeenPods = () => {
  const navigate = useNavigate();
  
  return (
    <motion.div 
      className="p-6 bg-card rounded-lg shadow-sm border"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Users className="h-5 w-5" /> Teen Pods
        </h2>
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Button onClick={() => navigate("/clubs")} size="sm">
            <PlusCircle className="mr-2 h-4 w-4" />
            Join Clubs
          </Button>
        </motion.div>
      </div>
      
      <div className="text-center py-8 bg-muted/20 rounded-lg border border-dashed">
        <p className="text-muted-foreground">No clubs joined yet</p>
        <p className="text-sm text-muted-foreground mt-1">Join your first club to connect with other teens</p>
      </div>
    </motion.div>
  );
};

export default TeenPods;
